import { useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { getCurrentMsalAccount, isAccountForUser } from "@/utils/sessionIdentity";

/**
 * Whether this tab has a OneView session that belongs to its current Microsoft account.
 *
 * The persisted Redux session alone is not trusted: it lives in localStorage, is
 * shared by every tab and survives restarts, so it can belong to a different
 * Microsoft account than the one signed in now.
 */
export const useVerifiedSession = () => {
  const { instance, accounts } = useMsal();
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);

  // Read the cache directly: MsalProvider's `accounts` starts empty until its startup
  // event, which would treat every page reload as unverified. Subscribing to `accounts`
  // still re-renders this hook whenever MSAL's accounts change.
  void accounts;
  const account = getCurrentMsalAccount(instance);
  return Boolean(isAuthenticated && isAccountForUser(account, user));
};
